export default __webpack_public_path__ + "static/media/dark-notofication-icon.d6128bf3.svg";